import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserRoleReducer } from '../reducers';

export const selectUserRoleFeature = createFeatureSelector<UserRoleReducer.DataState>(UserRoleReducer.featureName);

export const selectFeatureUserRole = createSelector(selectUserRoleFeature, (state: UserRoleReducer.DataState) => state.detail);
